// @ts-nocheck
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getText } from "../../../../utils/util";
import "./index.css";

export default function CenterPage({
  list,
  isShowZF,
  setVisibleCK,
  setcurrencyId,
  currencyId,
  setVisibleCKTS2
}) {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const lan = localStorage.getItem("i18n");
  const getArray = () => {
    const nodes = [];
    for (const item of list) {
      nodes.push(
        <div
          className="flex justify-between items-center p-4 border-b border-neutral-700 hover:bg-neutral-800 transition-colors duration-200 cursor-pointer"
          onClick={() => {
            if(isShowZF){
              setVisibleCKTS2(true);
              return
            }
            setVisibleCK(true);
            setcurrencyId(item?.id);
          }}
        >
          <div className="flex items-center text-neutral-100 text-base">
            <div className="relative w-8 h-8 mr-3 overflow-hidden">
              <img
                src="/costIco/20220324033547378184.png"
                draggable="true"
                className="w-full h-full absolute top-0 left-0 object-cover"
              />
              <div className="absolute inset-0 overflow-hidden hidden">
                <div className="absolute inset-0 overflow-hidden">
                  <div className="absolute left-0 top-0 w-full h-full"></div>
                </div>
                <div className="absolute inset-0 overflow-hidden">
                  <div className="absolute left-0 top-0 w-full h-full"></div>
                </div>
              </div>
            </div>
            <span className="font-medium">
              {lan == "zh" ? item.name : item.currency+" "}
              {translate(getText("充值"))}
            </span>
          </div>
          <i className="text-primary-light text-lg fa fa-angle-right"></i>
        </div>
      );
    }
    return nodes;
  };

  return (
    <div className="w-full">
      <div className="w-full min-h-full">
        <div className="w-full">
          <div className="bg-neutral-800 rounded-lg shadow-card mb-4">
            <p className="p-3 text-base text-neutral-200 border-b border-neutral-700">{translate(getText("請選擇充值通道"))}</p>
            <div className="divide-y divide-neutral-700">
              {getArray()}
            </div>
          </div>
          <div className="h-6"></div>
        </div>
      </div>

      <div className="h-6"></div>
    </div>
  );
}
